import { render } from "./MenuLink.vue?vue&type=template&id=42908a78"
import script from "./MenuLink.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLink.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/sarahmarinoff/Sites/fc2025/wp-content/plugins/baytek-portal-helper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/MenuLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42908a78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42908a78', __exports__)) {
    console.log('reload')
    api.reload('42908a78', __exports__)
  }
  
  module.hot.accept("./MenuLink.vue?vue&type=template&id=42908a78", () => {
    console.log('re-render')
    api.rerender('42908a78', render)
  })

}


export default __exports__